import { ErrorMessage } from '@hookform/error-message';
import classNames from 'classnames';
import _ from 'lodash';
import { getDefaultInputDate } from '../../commons/utils/date.util';
import Paper from '../Paper';
import PublicFileInput from '../PublicFileInput';
import { getPattern } from './patters';
import './style.scss';

interface PublicFormInputProps {
  register: any;
  question: string;
  questionId: string;
  type: string;
  options?: string[];
  errors: any;
  disabled?: boolean;
  currentValue?: string;
  setValue?: any;
}

const PublicFormInput = ({
  register,
  question,
  questionId,
  type,
  options,
  errors,
  currentValue,
  setValue,
  disabled = false
}: PublicFormInputProps) => {
  const registerCommonOptions = {
    required: 'Esta pregunta es obligatoria.'
  };

  // Using closure in all the functions
  const getTypedInput = (inputType: string) => (
    <input
      {...register(questionId, {
        ...registerCommonOptions,
        pattern: getPattern(inputType)
      })}
      className="form-input"
      type={inputType}
      placeholder="Tu respuesta"
      disabled={disabled}
    />
  );

  const getSelectInput = () =>
    _.map(options, (option, idx) => (
      <label key={idx} className="form-input-label">
        <input
          {...register(questionId, { ...registerCommonOptions })}
          className="form-input"
          type="radio"
          value={idx}
          disabled={disabled}
        />
        {option}
      </label>
    ));

  const getDateInput = () => (
    <input
      {...register(questionId, { ...registerCommonOptions })}
      className="form-input"
      type="date"
      defaultValue={getDefaultInputDate()}
      disabled={disabled}
    />
  );

  const renderInput = () => {
    switch (type) {
      case 'TEXT': {
        return getTypedInput('text');
      }
      case 'EMAIL': {
        return getTypedInput('email');
      }
      case 'URL': {
        return getTypedInput('url');
      }
      case 'SELECT': {
        return getSelectInput();
      }
      case 'DATE': {
        return getDateInput();
      }
      case 'FILE': {
        return (
          <PublicFileInput
            register={register}
            questionId={questionId}
            currentValue={currentValue}
            setValue={setValue}
            disabled={disabled}
          />
        );
      }
      default: {
        return null;
      }
    }
  };

  const paperClassName = classNames({
    'question-container': true,
    'border-color-error': errors[questionId]
  });

  return (
    <Paper className={paperClassName}>
      <div className="form-question mb-3">
        <span>{question}</span>
      </div>
      <div>{renderInput()}</div>
      <div>
        <ErrorMessage
          errors={errors}
          name={questionId}
          render={({ messages }) => {
            return messages
              ? Object.entries(messages).map(([messageType, message]) => {
                  return (
                    <p key={messageType} className="error-message">
                      {message}
                    </p>
                  );
                })
              : null;
          }}
        />
      </div>
    </Paper>
  );
};

export default PublicFormInput;
